import { TermCondition } from "../../containers/termCondition"

export const Term = () => {
    return (
        <TermCondition />
    )
}